import { render, staticRenderFns } from "./EZCardBindingTpass.vue?vue&type=template&id=3cd2cf0f&scoped=true"
import script from "./EZCardBindingTpass.vue?vue&type=script&lang=js"
export * from "./EZCardBindingTpass.vue?vue&type=script&lang=js"
import style0 from "./EZCardBindingTpass.vue?vue&type=style&index=0&id=3cd2cf0f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd2cf0f",
  null
  
)

export default component.exports